import { ApiService } from "@core/api/api-service";
import { TutorialBannerType, TutorialLinks } from "@domain/tutorial-banner/tutorial-banner-manager";

export class TutorialBannerService {
	constructor(private readonly apiService: ApiService) {}

	async getTutorialLinks(): Promise<TutorialLinks> {
		const tutorialsDto = await this.apiService.get<TutorialDto[]>("/pts/me/video-tutorials");

		return this.getTutorialsFromDto(tutorialsDto.data);
	}

	private getTutorialsFromDto(dto: TutorialDto[]): TutorialLinks {
		const tutorials: TutorialLinks = {
			[TutorialBannerType.INVITE_TO_HCT]: undefined,
			[TutorialBannerType.MONITOR_PATIENT_PROGRAM]: undefined,
		};

		dto.forEach(tutorial => {
			tutorials[tutorial.type as TutorialBannerType] = {
				videoUrl: tutorial.videoUrl,
			};
		});

		return tutorials;
	}
}

interface TutorialDto {
	type: string;
	videoUrl: string;
}
